import { render } from "./Shelves.vue?vue&type=template&id=eaa473da&scoped=true"
import script from "./Shelves.vue?vue&type=script&lang=js"
export * from "./Shelves.vue?vue&type=script&lang=js"

import "./Shelves.vue?vue&type=style&index=0&id=eaa473da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eaa473da"]])

export default __exports__